'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPrevMonth = {};

exports.__exports = isPrevMonth;
